/**
 * Resolve the origin of the Scale Mediation portal (the mediator-facing app).
 *
 * The Case Manager app is served from a different domain and does not serve
 * /embed, so window.location.origin is never the right answer for a booking or
 * corporate-code link.
 *
 * This rule was already copied by hand into three places — BookingLinkTab.jsx,
 * OnboardingLinks.jsx and utils/scaleApi.js — which is how the UAT case came to
 * be missed in one of them and handed out app.scalemediation.com links for
 * cases that only existed on UAT. New callers import this; the existing three
 * should migrate to it rather than a fourth copy being made.
 */
export function resolvePortalOrigin() {
  if (process.env.REACT_APP_SCALE_PORTAL_URL) return process.env.REACT_APP_SCALE_PORTAL_URL;
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host.includes('uat')) return 'https://app-uat.scalemediation.com';
  const isStaging =
    host.includes('staging') ||
    host.includes('localhost') ||
    host.includes('127.0.0.1') ||
    host.includes('.onrender.com');
  return isStaging
    ? 'https://staging.scalemediation.com'
    : 'https://app.scalemediation.com';
}

/**
 * The booking URL for a mediator, optionally carrying a corporate code.
 * /embed/:mediator resolves the mediator by user_id (uuid), not the integer id.
 * Shape matches scale-portal's own handleCopyURL (CouponCode.jsx:150-152).
 */
export function bookingUrl(userId, corporateCode) {
  if (!userId) return '';
  const base = `${resolvePortalOrigin()}/embed/${userId}`;
  return corporateCode ? `${base}/?corporate=${encodeURIComponent(corporateCode)}` : base;
}
